import { Tabs } from 'expo-router';
import { useState } from 'react';

import { AuthenticatedBottomTabBar } from '@/src/components/AuthenticatedBottomTabBar';
import {
  AuthenticatedHeader,
  AuthenticatedHeaderSearchButton,
} from '@/src/components/AuthenticatedHeader';
import { UserSearchModal } from '@/src/features/profile/UserSearchModal';
import { scrollTabToTop } from '@/src/utils/tab-scroll';

export default function AppTabsLayout() {
  const [searchModalVisible, setSearchModalVisible] = useState(false);

  return (
    <>
      <Tabs
        screenOptions={{
          animation: 'none',
          header: () => (
            <AuthenticatedHeader
              right={
                <AuthenticatedHeaderSearchButton
                  onPress={() => setSearchModalVisible(true)}
                />
              }
            />
          ),
          headerShown: true,
        }}
        tabBar={({ navigation, state }) => (
          <AuthenticatedBottomTabBar
            activeRouteName={state.routes[state.index]?.name}
            onNavigate={(routeName) => {
              const route = state.routes.find(
                (candidate) => candidate.name === routeName,
              );
              const event = navigation.emit({
                canPreventDefault: true,
                target: route?.key,
                type: 'tabPress',
              });

              if (!event.defaultPrevented) {
                navigation.navigate(routeName);
              }
            }}
          />
        )}
      >
        <Tabs.Screen
          name="home"
          listeners={{
            tabPress: () => scrollTabToTop('home'),
          }}
          options={{
            title: 'Public',
          }}
        />
        <Tabs.Screen
          name="friends"
          listeners={{
            tabPress: () => scrollTabToTop('friends'),
          }}
          options={{
            title: 'Frienzzone',
          }}
        />
        <Tabs.Screen
          name="create"
          options={{
            animation: 'fade',
            href: null,
            title: '',
          }}
        />
        <Tabs.Screen
          name="notifications"
          listeners={{
            tabPress: () => scrollTabToTop('notifications'),
          }}
          options={{
            title: 'Notifications',
          }}
        />
        <Tabs.Screen
          name="profile"
          listeners={{
            tabPress: () => scrollTabToTop('profile'),
          }}
          options={{
            title: 'Profile',
          }}
        />
        <Tabs.Screen
          name="compose"
          options={{ animation: 'fade', href: null, title: '' }}
        />
        <Tabs.Screen
          name="settings"
          options={{ animation: 'fade', href: null, title: '' }}
        />
        <Tabs.Screen
          name="users/[uid]"
          options={{
            animation: 'none',
            href: null,
            title: '',
          }}
        />
        <Tabs.Screen
          name="legal-consent"
          options={{
            animation: 'fade',
            header: () => <AuthenticatedHeader />,
            href: null,
            title: '',
          }}
        />
        <Tabs.Screen
          name="onboarding"
          options={{
            animation: 'fade',
            header: () => <AuthenticatedHeader />,
            href: null,
            title: '',
          }}
        />
      </Tabs>
      <UserSearchModal
        visible={searchModalVisible}
        onClose={() => setSearchModalVisible(false)}
      />
    </>
  );
}
